import React, {Component} from 'react';
import GridListTile from '@material-ui/core/GridListTile';
import {FormattedMessage} from 'react-intl';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import GridList from '@material-ui/core/GridList';
import PropTypes from 'prop-types';

export class ChartExtensions extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}
	static propTypes = {
		onCreatePlot: PropTypes.func.isRequired,
		titleColor: PropTypes.string.isRequired,
	};

	render() {
		return (
			<GridList
				cols={6}
				cellHeight={40}
				spacing={4}
				style={{
					width: '270px',
					margin: '1px'
				}}
			>
				<GridListTile
					cols={6}
					style={{
						height: '24px'
					}}
				>
					<div
						style={{
							backgroundColor: this.props.titleColor,
							color: 'white',
							fontSize: '9pt',
							padding: '3px'
						}}
					>
						<FormattedMessage id="StreamChart.TypesGauge" defaultMessage="Gauge Charts"/>
					</div>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.Gauge" defaultMessage="Gauge"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('gauge')}
						>
							<img alt="" src="images/charts/gauge.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.Gauge23" defaultMessage="Gauge 2/3"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('gauge23')}
						>
							<img alt="" src="images/charts/gauge23.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.GaugeValue" defaultMessage="Gauge Value"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('gaugevalue')}
						>
							<img alt="" src="images/charts/gaugevalue.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.GaugePointer" defaultMessage="Gauge Pointer"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('gaugepointer')}
						>
							<img alt="" src="images/charts/gaugepointer.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile
					cols={6}
					style={{
						height: '24px'
					}}
				>
					<div
						style={{
							backgroundColor: this.props.titleColor,
							color: 'white',
							fontSize: '9pt',
							padding: '3px'
						}}
					>
						<FormattedMessage id="StreamChart.TypesState" defaultMessage="State Charts"/>
					</div>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.StateColumn" defaultMessage="State Column"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('statecolumn')}
						>
							<img alt="" src="images/charts/statecolumn.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.StateTime" defaultMessage="State Time"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('statetime')}
						>
							<img alt="" src="images/charts/statetime.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.StatePeriod" defaultMessage="State Period"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('stateperiod')}
						>
							<img alt="" src="images/charts/stateperiod.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile
					cols={6}
					style={{
						height: '24px'
					}}
				>
					<div
						style={{
							backgroundColor: this.props.titleColor,
							color: 'white',
							fontSize: '9pt',
							padding: '3px'
						}}
					>
						<FormattedMessage id="StreamChart.TypesStock" defaultMessage="Stock Charts"/>
					</div>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.HighLowClose" defaultMessage="High Low Close"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('stockHLC')}
						>
							<img alt="" src="images/charts/stockhlc.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.OpenHighLowClose" defaultMessage="Open High Low Close"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('stockOHLC')}
						>
							<img alt="" src="images/charts/stockohlc.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.VolumeHighLowClose" defaultMessage="Volume High Low Close"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('stockVHLC')}
						>
							<img alt="" src="images/charts/stockvhlc.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.VolumeOpenHighLowClose" defaultMessage="Volume Open High Low Close"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('stockVOHLC')}
						>
							<img alt="" src="images/charts/stockvohlc.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile
					cols={6}
					style={{
						height: '24px'
					}}
				>
					<div
						style={{
							backgroundColor: this.props.titleColor,
							color: 'white',
							fontSize: '9pt',
							padding: '3px'
						}}
					>
						<FormattedMessage id="StreamChart.TypesFunnel" defaultMessage="Funnel Charts"/>
					</div>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.Funnel" defaultMessage="Funnel"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('funnel')}
						>
							<img alt="" src="images/charts/funnel.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.FunnelBar" defaultMessage="Funnel Bar"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('funnelbar')}
						>
							<img alt="" src="images/charts/funnelbar.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.HorizontalFunnel" defaultMessage="Horizontal Funnel"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('funnelhorizontal')}
						>
							<img alt="" src="images/charts/funnelhorz.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.HorizontalFunnelColumn" defaultMessage="Horizontal Funnel Column"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('funnelhorizontalcolumn')}
						>
							<img alt="" src="images/charts/funnelhorzcolumn.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile
					cols={6}
					style={{
						height: '24px'
					}}
				>
					<div
						style={{
							backgroundColor: this.props.titleColor,
							color: 'white',
							fontSize: '9pt',
							padding: '3px'
						}}
					>
						<FormattedMessage id="StreamChart.TypesOther" defaultMessage="Other Charts"/>
					</div>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.Waterfall" defaultMessage="Waterfall Chart"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('waterfall')}
						>
							<img alt="" src="images/charts/waterfall.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.BoxPlot" defaultMessage="Box Plot"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('boxplot')}
						>
							<img alt="" src="images/charts/boxplot.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
				<GridListTile cols={1}>
					<Tooltip
						enterDelay={300}
						title={<FormattedMessage id="StreamChart.Map" defaultMessage="Map"/>}
					>
						<IconButton
							style={{borderRadius: '0%', padding: '0px', width: '40px', height: '40px'}}
							color="inherit"
							onClick={() => this.props.onCreatePlot('map')}
						>
							<img alt="" src="images/charts/map.png"/>
						</IconButton>
					</Tooltip>
				</GridListTile>
			</GridList>
		);
	}
}



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/ChartExtensions.js